import { array } from "prop-types";
import React, { useState, useEffect } from "react";
import { Form, Grid, Card, Table, Alert, Button, Icon, Dimmer, Tab } from "tabler-react";

export const ContentReportesGenerales = ({ data, sinColumnas, opciones }) => {
	const [headers, setHeaders] = useState([]);
	const [content, setContent] = useState([]);

	useEffect(() => {
		if (data !== undefined) {
			let bool = true;
			let headers = [];
			let content = [];
			
			// Verificar si alguna plataforma seleccionada es 61 o 1316
			const plataformasEspeciales = opciones?.tempPlataformaN?.some(p => p.value === 61 || p.value === 1316 || p.value === 1711);
			
			const COLUMN_RENAMES = {
				arribo_direcion_carga: 'Llegada de Unidad a centro de carga',
				reporte_centro_carga: 'Reporte de Operador / reporte en centro de carga',
				asignacion_cortina_centro_carga: 'Asignación de Cortina en centro carga',
				inicio_de_carga: 'Inicio de carga',
				cita_programada: 'Cita en cliente',
				inicio_ruta: 'Salida de Centro de Carga/Inicio de ruta',
				arribo_cliente_lleno: 'Llegada a Cliente',
				hora_maxima_salida: 'Hora de máxima salida',
				fin_de_carga: 'Fin de carga',
				entrega_documentos_control_tower: 'Entrega de documentos a control tower',
				entrega_documentos: 'Entrega de documentos en cliente',
				asignacion_rampa: 'Asignación de Rampa',
				inicio_de_descarga: 'Inicio de Descarga',
				entrega_de_pods: 'Entrega de PODs',
				fin_de_descarga: 'Fin de Descarga',
				cita_programada_terminal: 'Cita en centro carga',
			};

			data.content.forEach((row, index) => {
				let columnas = [];
				let sanitized = typeof row === 'string' 
					? row.replace(/[\x00-\x1F\x7F]/g, ' ').replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => { const code = parseInt(hex, 16); return code <= 0x1F || code === 0x7F ? ' ' : match; })
					: null;
				let parsedRow;
				try { parsedRow = typeof row === 'object' ? row : JSON.parse(sanitized); } catch(e) { return; }
				Object.entries(parsedRow).forEach(([key, columna]) => {
					if (!sinColumnas.includes(key)) {
						if (bool) {
							const titulo = plataformasEspeciales && COLUMN_RENAMES[key] ? COLUMN_RENAMES[key] : key;
							headers.push(<th key={key}>{titulo}</th>);
						}
						columnas.push(<Table.Col key={`${index}-${key}`}>{columna}</Table.Col>);
					}
				});
				bool = false;
				content.push(<Table.Row key={index}>{columnas}</Table.Row>);
			});
			setHeaders(headers);
			setContent(content);
		}
	}, [data]);

	return (
		<div>
			{content.length > 0 ? (
				<Table
					cards={true}
					striped={true}
					responsive={true}
					className="table-center col-12 table-bordered"
					style={{ color: "black", fontSize: "80%" }}
				>
					<Table.Header className="thead-dark">
						<tr style={{ fontSize: "80%", lineHeight: "1.2" }}>{headers}</tr>
					</Table.Header>
					<Table.Body>{content}</Table.Body>
				</Table>
			) : (
				<div className="alert alert-dark w-100 mt-6" role="alert">
					No hay resultados que mostrar...
				</div>
			)}
		</div>
	);
};
